var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.66675C14.8682 2.66675 15.1667 2.96522 15.1667 3.33341V12.6667C15.1667 13.0349 14.8682 13.3334 14.5 13.3334H2.50004C2.13185 13.3334 1.83337 13.0349 1.83337 12.6667V3.33341C1.83337 2.96522 2.13185 2.66675 2.50004 2.66675H14.5ZM13.8334 4.83208L8.90004 8.53341C8.663 8.71119 8.33708 8.71119 8.10004 8.53341L3.16671 4.83275V12.0001H13.8334V4.83208ZM12.7207 4.00008H4.27871L8.50004 7.16675L12.7207 4.00008Z",
    fill: "#767676"
  })));
};
export { SvgMailIcon as ReactComponent };
export default __webpack_public_path__ + "assets/4eafb5e5.svg";